export const images = {
  hero: "/images/hero.webp",
  pool: "/images/pool.webp",
  lounge: "/images/lounge.webp",
  agave: "/images/agave.webp",
  archConstruction: "/images/arch-construction.webp",
  tiles: "/images/tiles.webp",
  sauna: "/images/sauna.webp",
  desert: "/images/desert.webp",
};

export const NAV_ITEMS = [
  { name: "The Vision", path: "/" },
  { name: "The Compound", path: "/gallery" },
  { name: "The Almanac", path: "/article" },
  { name: "The Groundwork", path: "/dispatch" },
  { name: "Brand Guide", path: "/brand" },
] as const;

export const COLOR_PALETTE = [
  { name: "Adobe Plaster", hex: "#ECE9E0", text: "#293129", desc: "Primary Background" },
  { name: "Deep Agave / Ink", hex: "#293129", text: "#ECE9E0", desc: "Primary Text & Structure" },
  { name: "Cobalt Mosaic", hex: "#1D4C74", text: "#ECE9E0", desc: "Water, Pools, Accents" },
  { name: "Terracotta Pink", hex: "#C06B5D", text: "#ECE9E0", desc: "Sunsets, Warmth, Earth" },
  { name: "Faded Sage", hex: "#8F9B82", text: "#ECE9E0", desc: "Flora, Shade, Softness" },
] as const;
